export default [
    '#FF062C', '#FF0062', '#ECBFEC', '#7432BB', '#3550B9',
    '#00B447', '#BFE6E1', '#00C1D6', '#00ADF8', '#BFE5FD',
    '#68C73A', '#C6DE03', '#FFFABF', '#FFBD00', '#FF8F00',
    '#FF5C06', '#5858FF', '#0653FF',
];



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/categories/colors.tsx